'use client';

import DynamicPageComponents from '@/components/dynamic/DynamicPageComponents/DynamicPageComponents';
import { PageContent } from '@/components/organisms/PageContent/PageContent';
import { usePageStore } from '@/store/usePageStore';
import { notFound, usePathname } from 'next/navigation';
import { generateWorkStructuredData } from './Work.structuredData';
import { localizedSlugs } from '@/i18n/routing';
import { useEffect } from 'react';

export const Work = ({
  data,
  isPreview = false,
  subSlug,
  isWorkSpecificPage = false,
}: {
  data: any;
  isPreview?: boolean;
  subSlug: string;
  isWorkSpecificPage?: boolean;
}) => {
  const langIso = usePageStore((s) => s.langIso);
  const pathname = usePathname();

  if (!data) {
    notFound();
  }

  useEffect(() => {
    usePageStore.getState().setProjectBreadcrumbPath(pathname);
  }, [pathname]);

  const stateSelector = usePageStore;
  const setCurrentSlugTranslations = stateSelector(
    (s) => s.setCurrentSlugTranslations
  );

  useEffect(() => {
    const baseSlug = {
      en: `/${localizedSlugs.work.en}`,
      es: `/es/${localizedSlugs.work.es}`
    }

    setCurrentSlugTranslations({
      en: isWorkSpecificPage
        ? `${data.config.slug.en}` || baseSlug.en
        : baseSlug.en,
      es: isWorkSpecificPage
        ? `${data.config.slug.es}` || baseSlug.es
        : baseSlug.es,
    })
  }, [setCurrentSlugTranslations, data.config?.slug?.en, data.config?.slug?.es, isWorkSpecificPage]);

  const structuredData = !isPreview
    ? generateWorkStructuredData({
        data,
        isWorkSpecificPage,
        subSlug,
        langIso,
      })
    : undefined;

  return (
    <PageContent
      contentPaddingTop={'lg'}
      includePrefooterBanner={false}
      isBlockedByLogin={isPreview || data.isDraft === true}
      {...(structuredData ? { structuredData } : {})}
    >
      <DynamicPageComponents components={data?.components} />
    </PageContent>
  );
};
